import { TRIGGER_FILTER_SHORTCUT } from 'events';
import { component } from 'picoapp';

export default component(async (node, ctx) => {
  const { blockId } = node.dataset;
  const trigger = node.querySelector('[data-trigger]');

  trigger.addEventListener('click', () => {
    ctx.emit(TRIGGER_FILTER_SHORTCUT, null, blockId);
  });
});
